




















































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  InstrumentStatus, DrivewealthAccountManagementType,
} from "@/shared/types";
import { Validator } from "vee-validate";
import InstrumentName from "@/shared/components/investments/drivewealth/InstrumentName.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { formatCurrency } from "@/shared/currency";
import SweepInstrumentSearch from "./SweepInstrumentSearch.vue";
import SelectListInstrumentSearch from "./SelectListInstrumentSearch.vue";
import ReviewAutomatedInvestmentFunding from "./ReviewAutomatedInvestmentFunding.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";

@Component({
  components: {
    InstrumentName,
    GenericLoadingSpinner,
    SweepInstrumentSearch,
    ReviewAutomatedInvestmentFunding,
    SelectListInstrumentSearch,
  }
})
export default class AutomatedInvestmentFunding extends Vue {
  formatCurrency = formatCurrency;
  $validator: Validator;
  isReviewing = false;
  notifierStore = useNotifierStore();
  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ default: false })
  isPreenrollment: boolean;

  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  drivewealthWizardStore = useDrivewealthWizardStore();

  mounted () {
    if (this.isPreenrollment) {
      this.drivewealthSweepStore.resetSweepForPreEnrollment({ username: this.username, partnerId: this.partnerId });
    } else {
      this.drivewealthSweepStore.resetSweepState({ username: this.username, partnerId: this.partnerId });
    }

    this.drivewealthStore.loadHsaBalanceAndThreshold({ username: this.username, partnerId: this.partnerId });
    this.drivewealthWizardStore.loadExistingPreenrollment({ username: this.username, partnerId: this.partnerId });
  }

  get isLoaded (): boolean {
    return this.drivewealthSweepStore.sweepLoaded &&
      this.drivewealthStore.isHsaBalanceAndThresholdLoaded(null) &&

      this.drivewealthSweepStore.isWorkingCopyInitialized &&
      this.drivewealthWizardStore.isEnrollmentLoaded;
  }

  get threshold (): number {
    return this.drivewealthSweepStore.investmentThreshold;
  }

  set threshold (value: number) {
    this.drivewealthSweepStore.setInvestmentThreshold(value);
  }

  get isReviewDisabled () {
    return !(this.drivewealthSweepStore.isActive && this.drivewealthSweepStore.isNormalized) || this.errors.any();
  }

  get accountType () {
    if (this.drivewealthStore.hasAnAccount) {
      return this.drivewealthStore.accountManagementType(0);
    }

    return this.drivewealthWizardStore.isPreenrolled ? this.drivewealthWizardStore.enrollmentAccountType : null;
  }

  get isSelectList () {
    return this.accountType === DrivewealthAccountManagementType.Advisory;
  }

  get isOpenBrokerage () {
    return this.accountType === DrivewealthAccountManagementType.OpenBrokerage;
  }

  get thresholdValidator () {
    return {
      required: true,
      decimal: 2,
      min_value_usd: this.drivewealthStore.hsaInvestmentThreshold
    };
  }

  onAllocationChanged () {
    this.drivewealthSweepStore.setDirty();
  }

  @Watch("drivewealthSweepStore.isDirty")
  onIsDirtyChanged () {
    this.updateNavigationGuard(this.drivewealthSweepStore.isDirty);
  }

  updateNavigationGuard (confirmNavigation: boolean) {
    const eventData = {
      confirmNavigation,
      message: "Are you sure you want to leave?  Your unsaved changes will be lost if you continue.  Click Cancel to return to the page to save your changes."
    };

    this.$emit("navigationGuardChange", eventData);
  }

  onPause () {
    this.drivewealthSweepStore.pauseSweep()
      .then(_ => {
        this.notifierStore.setSuccess("Automated investment funding is now inactive.");
        this.updateNavigationGuard(false);
        this.$emit("complete");
      })
      .catch(err => {
        this.notifierStore.setDanger(`Failed to pause automated investment funding`);
      });
  }

  onResume () {
    this.drivewealthSweepStore.setIsActive(true);
  }

  onCancel () {
    this.updateNavigationGuard(false);

    if (!this.drivewealthSweepStore.sweepIsActive && this.drivewealthSweepStore.isActive &&
      this.drivewealthSweepStore.sweepWasActive) {
      // they hit the resume button, but not the Review => Accept buttons
      const eventData = {
        confirmNavigation: true,
        message: "Are you sure you want to leave?  Automated investment funding will not resume until it is reviewed and accepted."
      };

      this.$emit("navigationGuardChange", eventData);
    }

    this.$emit("complete");
  }

  onReview () {
    this.$validator.validate()
      .then(isValid => {
        if (isValid) {
          this.isReviewing = true;
          this.drivewealthSweepStore.removeInvalidAllocations();
        }
      })
      .catch();
  }

  onMakeChanges () {
    this.isReviewing = false;
  }

  onAfterAccept () {
    this.updateNavigationGuard(false);
    this.$emit("complete");
  }

  allocationFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Investment"
    },
    {
      key: "icon",
      label: "",
      thClass: "text-center",
      tdClass: "text-right"
    },
    {
      key: "purchaseAllocation",
      label: "% Asset Allocation",
      thClass: "text-center"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center"
    },
  ];

  get allocationItems () {
    if (!this.drivewealthSweepStore.selectedInstruments) {
      return [];
    }

    return this.drivewealthSweepStore.selectedInstruments.map((instrument, index) => ({
      instrument: {
        symbol: instrument.stockSymbol,
        companyName: instrument.companyName,
        website: instrument.website,
        imageUrl: instrument.imageUrl,
        isActive: instrument.status === InstrumentStatus.Active
      },
      purchaseAllocation: instrument,
      action: index,
    }));
  }
}
